import type { RadioCardProps } from '@mantine/core';
import { Flex, Group, Radio, Text } from '@mantine/core';
import React, { forwardRef } from 'react';

import styles from './RadioCard.module.css';

interface CardProps extends RadioCardProps {
  label: string;
}

export const LBRadioCard = forwardRef<
  React.ElementRef<typeof Radio.Card>,
  CardProps & { label: string }
>(({ children, label, ...props }, ref) => (
  <Radio.Card ref={ref} className={styles.root} radius='md' {...props}>
    <Flex direction='column'>
      <Group align='center' wrap='nowrap'>
        <Radio.Indicator />
        <Text>{label}</Text>
      </Group>
      <Group className='content'>{children}</Group>
    </Flex>
  </Radio.Card>
));
